<template>
  <v-container fluid fill-height>
    <v-layout
      justify-center
      align-center
    >
      <v-flex xs7 md5>
        <v-card class="elevation-1">
          <v-toolbar color="primary">
            <v-btn icon class="white--text" @click="goBack">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title class="white--text">Update Admin</v-toolbar-title>
          </v-toolbar>
              <v-card-title>
                <v-container fluid>
                  <v-layout row>
                    <v-flex>
                      <v-text-field
                        name="input-1"
                        v-model="admin.user.first_name"
                        label="First Name"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex>
                      <v-text-field
                        name="input-1"
                        v-model="admin.user.last_name"
                        label="Last Name"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex>
                      <v-text-field
                        name="input-1"
                        label="Email"
                        v-model="admin.user.email"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex>
                      <v-text-field
                        name="input-8-1"
                        label="Enter your password"
                        v-model="admin.user.password"
                        min="8"
                        :rules="rules.passwordRules"
                        :append-icon="visibility ? 'visibility' : 'visibility_off'"
                        :append-icon-cb="() => (visibility = !visibility)"
                        :type="visibility ? 'password' : 'text'"
                        counter
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex>
                      <v-text-field
                        name="input-8-1"
                        label="Confirm your password"
                        v-model="confirmPassword"
                        min="8"
                        :rules="rules.passwordRulesConfirm"
                        :append-icon="visibilityConfirm ? 'visibility' : 'visibility_off'"
                        :append-icon-cb="() => (visibilityConfirm = !visibilityConfirm)"
                        :type="visibilityConfirm ? 'password' : 'text'"
                        counter
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-card-actions>
                    <v-btn color="warning" @click.prevent="post" :disabled="!valid"
                    >Update</v-btn>
                  </v-card-actions>
                </v-container>
            </v-card-title>
        </v-card>
      </v-flex>
      <v-alert
        color="success"
        icon="check_circle"
        :value="alert"
        transition="scale-transition"
      >
        You have successfully updated admin's data.
      </v-alert>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      admin: {
      "user": {
        "email": "",
        "first_name": "",
        "last_name": "",
        "password": ""
          }
      },
      valid: true,
      confirmPassword: "",
      visibility: true,
      visibilityConfirm: true,
      rules: {
        fieldRules: [v => !!v || "Field is required"],
        phoneValidation: [v => /^(\+\d{1,3}[- ]?)?\d{0,20}$/.test(v) || "Phone number is not valid."],
        passwordRules: [
          v => (v.length >= 8 || !v) || "Password must be at least 8 characters"
        ],
        passwordRulesConfirm: [
          v => (v == this.admin.user.password || !v) || "Password not confirmed",
          v => (v.length >= 8 || !v) || "Password must be at least 8 characters"
        ],
        emailRules: [
          v =>
            /\S+@\S+\.\S+/.test(v) ||
            "E-mail must be valid"
        ]
      },
      e1: true,
      alert: false
    };
  },
  mounted: function() {
    this.getAdmin();
  },
  watch: {
    "admin.user.password": function (val) {
      this.confirmPassword = '';
      if (val && val !== this.confirmPassword) {
        this.valid = false
      } else if (!val && !this.confirmPassword) {
        this.valid = true
      } else if (val && this.admin.user.password === val){ 
        this.valid = true
      } else {
        return false
      }
    },
    confirmPassword: function (val) {
      if (val !== "" && val === this.admin.user.password) {
        this.valid = true
      } else if (!val && !this.admin.user.password) {
        this.valid = true
      } else {
        this.valid = false
      } 
    }
  },
  methods: {
    alerting(){
      this.alert = !this.alert;
      setTimeout(() => {
            this.alert = !this.alert;
        }, 2500);
    },
    goBack(){
      this.$router.push("/admin/admins");
    },
    getAdmin() {
      axios.get("/users/" + this.$route.params.id).then(res => {
        this.admin.user = res.data.user;
      });
    },
    post() {
      axios.put('/users/' + this.$route.params.id, this.admin)
      .then(res => {
        this.alerting();
      })
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/Admins/AdminsEdit.vue